import { Spin } from 'antd';

/**
 * Shown inside a layout's content area while a lazily-loaded page chunk is
 * fetched (see the route-level code splitting note in App.tsx). The shell —
 * sidebar, header — stays on screen; only the page area shows the spinner.
 * Fixed min-height so the area does not collapse to nothing and jump.
 */
export default function RouteFallback() {
  return (
    <div
      role="status"
      aria-busy="true"
      style={{ minHeight: 240, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Spin size="large" />
    </div>
  );
}
